import {
  HelperText,
  TextField,
  TextFieldLabel,
  TextFieldTextArea,
} from "@hireart/component-library";
import PropTypes from "prop-types";
import {
  MAX_LENGTH,
  TIMESHEET_NOTES_VARIANT,
  VARIANT_CONFIG,
} from "./constants";

/**
 * TimesheetNotes - Generic component for timesheet notes
 * Supports both employee and employer notes with configurable behavior
 */
export const TimesheetNotes = ({
  variant = TIMESHEET_NOTES_VARIANT.EMPLOYEE,
  value = "",
  onChange,
  isDisabled = false,
}) => {
  const config = VARIANT_CONFIG[variant];
  const textAreaId = config.id;
  // Use context-aware helper text: editing vs viewing
  const helperText = isDisabled
    ? config.helperTextViewing
    : config.helperTextEditing;

  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  return (
    <div className="my-16">
      <TextField isOptional isDisabled={isDisabled} className="mb-2">
        <div className="flex items-center justify-between">
          <TextFieldLabel isUnstyled={isDisabled} htmlFor={textAreaId}>
            {config.label}
          </TextFieldLabel>
          {!isDisabled && (
            <span className="body-3 text-neutral-60">
              {value.length}/{MAX_LENGTH}
            </span>
          )}
        </div>
        <TextFieldTextArea
          id={textAreaId}
          name={textAreaId}
          value={value}
          onChange={handleChange}
          maxLength={MAX_LENGTH}
          rows={4}
          className="w-full border-2 border-neutral-20 bg-neutral-10 hover:bg-neutral-10"
          aria-describedby={`${textAreaId}-helper`}
        />
      </TextField>
      <HelperText id={`${textAreaId}-helper`} className="text-neutral-60">
        {helperText}
      </HelperText>
    </div>
  );
};

TimesheetNotes.propTypes = {
  variant: PropTypes.oneOf([
    TIMESHEET_NOTES_VARIANT.EMPLOYEE,
    TIMESHEET_NOTES_VARIANT.EMPLOYER,
  ]).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
};
